<div class="min-h-screen lg:flex">
  <div>
    <app-sidebar></app-sidebar>
    <app-backdrop></app-backdrop>
  </div>
  <div class="flex-1 transition-all duration-300 ease-in-out overflow-x-hidden" [ngClass]="{
        'md:ml-[290px]': (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async),
        'md:ml-[90px]': !((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async))
      }">
    <!-- app header start -->
    <app-header />
    <!-- app header end -->
    <div class="p-4 md:p-6 max-w-screen-2xl mx-auto">
      <app-password-expiry-banner />
      <router-outlet></router-outlet>
    </div>
  </div>
</div>